<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.name" placeholder="项目/联系人/电话" />
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.customer_id"  clearable filterable  placeholder="甲方">
                                        <Option :value="item.id" v-for="(item,index) in customerList" :key="index">{{item.company}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.type_id"  clearable filterable  placeholder="类型">
                                        <Option :value="item.type_id" v-for="(item,index) in typeList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.head_id"  clearable filterable  placeholder="负责人">
                                        <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button type="primary" size="small" class="text-font-sm" @click="createData"><Icon type="md-add" /> 创建项目</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="project_id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" :data="dataList.data" no-data-text="暂无数据记录">
                                <template #name="{ row }">
                                    <div @click="showData(row.project_id)" class="d-width text-primary cursor" :title="row.name">
                                        <span>{{row.name}}</span>
                                    </div>
                                </template>
                                <template #contract_money="{ row }">
                                    <div class="d-width" :title="row.contract_money">
                                        <strong class="text-violet">{{row.contract_money}}</strong>
                                    </div>
                                </template>
                                <template #money="{ row }">
                                    <div class="d-width" :title="row.money">
                                        <strong class="text-success">{{row.money}}</strong>
                                    </div>
                                </template>
                                <template #contract_signa_name="{ row }">
                                    <div class="d-width" :title="row.contract_signa_name">
                                        {{row.contract_signa_name}}
                                    </div>
                                </template>
                                <template #contract_start_time="{ row }">
                                    <div class="d-width" :title="row.contract_start_time + '~' + row.contract_end_time">
                                        {{row.contract_start_time}} ~ {{row.contract_end_time}}
                                    </div>
                                </template>
                                <template #contract_file="{ row }">
                                    <div class="d-width" >
                                        <a @click="FileDownload(row.contract_file)" href="javascript:void(0);" class="text-orange" v-if="!!row.contract_file">下载资料</a>
                                        <small v-else class="text-999">-</small>
                                    </div>
                                </template>
                                <template #company="{ row }">
                                    <div @click="customerData(row.customer_id)" class="d-width cursor" :title="row.company">
                                        <Poptip trigger="hover" title="联系方式" >
                                            <span>{{row.company}}</span>
                                            <template #content>
                                                <p>公司：{{row.company}}</p>
                                                <p>称呼：{{row.customer_real_name}}</p>
                                                <p>电话：{{row.customer_mobile}}</p>
                                                <p v-if="!!row.customer_wechat">微信：{{row.customer_wechat}}</p>
                                            </template>
                                        </Poptip>
                                    </div>
                                </template>
                                <template #type_id="{ row }">
                                    <div class="d-width" :title="row.type_name">
                                        <Tag>{{row.type_name}}</Tag>
                                    </div>
                                </template>
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 6" color="blue" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 7" color="green" :text="row.status_name" />
                                    <Badge v-else color="#999999" :text="row.status_name" />
                                </template>
                                <template #action="{ row }">
                                    <a class="text-font-sm text-orange" title="签订合同" v-if="row.status === 6 && $store.state.userinfo.admin_id === row.head_id" @click="contractData(row.project_id, row.name)">签订</a>
                                    <a class="text-font-sm text-orange" title="项目施工" v-if="row.status === 7 && $store.state.userinfo.admin_id === row.head_id" @click="workTrueData(row.project_id, row.name)">施工</a>
                                    <Divider v-if="row.status === 6 || row.status === 7" type="vertical"/>
                                    <a class="text-font-sm text-primary" title="项目报价" v-if="(row.status === 3 || row.status === 4 || row.status === 5 || row.status === 6) && $store.state.userinfo.admin_id === row.head_id " @click="quoteData(row.project_id, row.name)">重报</a>
                                    <a class="text-font-sm text-primary" title="更新合同" v-if="row.status === 7 && $store.state.userinfo.admin_id === row.head_id " @click="contractData(row.project_id, row.name)">重签</a>
                                    <Divider v-if="(row.status === 3 || row.status === 4 || row.status === 5 || row.status === 6  || row.status === 7) && $store.state.userinfo.admin_id === row.head_id" type="vertical"/>
                                    <a class="text-font-sm text-violet" @click="logData(row.project_id, row.name)">日志</a>
                                    <Divider type="vertical" v-if="$store.state.userinfo.admin_id === row.head_id || $store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2"/>
                                    <a class="text-font-sm text-primary" @click="editData(row.project_id)" v-if="$store.state.userinfo.admin_id === row.head_id || $store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2">编辑</a>
                                </template>
                            </Table>
                            <div class="em-page em-flex">
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="saveData"></add-modal>

                    <!-- 详情  -->
                    <show-modal v-if="is_show" ref="ShowRef"></show-modal>

                    <!-- 客户详情 -->
                    <customer-show-modal v-if="is_customer" ref="CustomerRef"></customer-show-modal>

                    <!-- 项目报价  -->
                    <quote-modal v-if="is_quote" ref="QuoteRef" @trueHandler="saveData"></quote-modal>

                    <!-- 签订合同  -->
                    <contract-modal v-if="is_contract" ref="ContractRef" @trueHandler="saveData"></contract-modal>

                    <!-- 项目施工  -->
                    <work-true-modal v-if="is_work_true" ref="WorkTrueRef" @trueHandler="saveData"></work-true-modal>

                    <!-- 项目日志  -->
                    <log-modal v-if="is_log" ref="LogRef"></log-modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import {getProjectContractList, getProjectConfig} from '@/apis/project'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "../public/Create";
import LogModal from "../public/Log";
import ShowModal from "../public/Show";
import QuoteModal from "../public/Quote";
import ContractModal from "../public/Contract";
import WorkTrueModal from "../public/WorkTrue";
import CustomerShowModal from "../../customer/index/Show";
export default {
    name: "ProjectContract",
    components: {
        Headers, Side, AddModal, ShowModal, QuoteModal, LogModal, ContractModal, CustomerShowModal, WorkTrueModal
    },
    data () {
        return {
            typeList: [],
            customerList: [],
            userList: [],

            search: {
                name: '',
                type_id: '',
                customer_id: '',
                head_id: ''
            },
            page : 1,
            pageSize : 15,
            selectCount  : 0,
            dataList : [],
            columns: [
                {
                    title: '项目名称',
                    key: 'name',
                    slot: 'name',
                    fixed : 'left',
                    minWidth: 240,
                },
                {
                    title: '合同金额',
                    key: 'contract_money',
                    slot: 'contract_money',
                    width: 140
                },
                {
                    title: '实际金额',
                    key: 'money',
                    slot: 'money',
                    width: 140
                },
                {
                    title: '报价金额',
                    key: 'quote_money',
                    width: 140
                },
                {
                    title: '签订人',
                    key: 'contract_signa_name',
                    slot: 'contract_signa_name',
                    width: 160
                },
                {
                    title: '有效期',
                    key: 'contract_start_time',
                    slot: 'contract_start_time',
                    width: 200
                },
                {
                    title: '合同资料',
                    key: 'contract_file',
                    slot: 'contract_file',
                    width: 120
                },
                {
                    title: '甲方',
                    key: 'company',
                    slot: 'company',
                    width: 200
                },
                {
                    title: '项目进度',
                    key: 'status',
                    slot : 'status',
                    width:120
                },
                {
                    title: '项目类型',
                    key: 'type_id',
                    slot: 'type_id',
                    width: 120
                },
                {
                    title: '负责人',
                    key: 'head_name',
                    width: 120
                },
                {
                    title: '更新',
                    key: 'update_time',
                    width:150
                },
                {
                    title: '操作',
                    key: 'action',
                    slot : 'action',
                    width : 190,
                    fixed : 'right'
                }
            ],
            is_create : false,
            is_show : false,
            is_contract : false,
            is_quote : false,
            is_log : false,
            is_customer : false,
            is_work_true : false,

        }
    },
    created(){
        this.getConfig();
        this.getList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {
        /**
         功能：
         time: 2025/12/20 13:35
         **/
        FileDownload(url){
            let that = this;
            if(url){
                //下载文件
                const fileUrl = this.$siteApi + url; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },
        /**
         功能：
         time: 2025/12/20 16:24
         **/
        customerData(customer_id){
            let that = this;
            that.is_customer = true;
            setTimeout(function(){
                that.$refs.CustomerRef.show(customer_id);
            })
        },
        /**
         功能：审批
         time: 2025/12/20 10:39
         **/
        contractData(project_id, name){
            let that = this;
            that.is_contract = true;
            setTimeout(function(){
                that.$refs.ContractRef.show(project_id, name);
            })
        },
        /**
         功能：开始施工
         time: 2025/12/20 17:18
         **/
        workTrueData(project_id, name){
            let that = this;
            that.is_work_true = true;
            setTimeout(function(){
                that.$refs.WorkTrueRef.show(project_id, name);
            })
        },
        /**
         功能：
         time: 2025/12/20 11:22
         **/
        quoteData(project_id, name){
            let that = this;
            that.is_quote = true;
            setTimeout(function(){
                that.$refs.QuoteRef.show(project_id, name);
            })
        },
        /**
         功能：
         time: 2025/12/20 10:39
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        /**
         功能：
         time: 2025/12/20 10:39
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                name: '',
                type_id: '',
                customer_id: '',
                head_id: ''
            };
            that.getList();
        },
        /**
         功能：
         time: 2025/12/18 14:07
         **/
        getConfig(){
            let that = this;
            getProjectConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.customerList = e.data.customerList ?? [];
                that.userList = e.data.userList ?? [];
            })
        },
        /**
         功能：
         time: 2025/12/20 10:39
         **/
        getList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getProjectContractList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         功能：
         time: 2025/12/20 10:40
         **/
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },
        /**
         功能：
         time: 2025/12/19 11:30
         **/
        createData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         功能：
         time: 2025/12/19 15:55
         **/
        editData(project_id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(project_id);
            })
        },
        /**
         功能：
         time: 2025/12/19 16:04
         **/
        saveData(){
            let that = this;
            that.getList();
        },
        /**
         功能：
         time: 2025/12/20 10:40
         **/
        logData(project_id, name ){
            let that = this;
            that.is_log = true;
            setTimeout(function(){
                that.$refs.LogRef.show(project_id, name);
            })
        },
        /**
         功能：
         time: 2025/12/20 10:40
         **/
        showData(project_id){
            let that = this;
            that.is_show = true;
            setTimeout(function(){
                that.$refs.ShowRef.show(project_id);
            })
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
